import React, { useState } from 'react'
import {
  Card,
  CardContent,
  Box,
  CardActions,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core'
import { useStyles, Input } from './styles'

const UserInfoByDocument = (props) => {
  const { users } = props
  const [alternative, setAlternative] = useState(0)
  const classes = useStyles()

  const onChangeFilter = (event) => {
    setAlternative(event.target.value)
  }

  const convertUser = (isArray) => {
    if (isArray.length > 0) {
      const copyOfArray = [].concat(isArray)
      const extract = copyOfArray.pop()
      const result = [extract.datos]

      return result
    }
    const result = isArray.datos
    return result
  }
  const getValues = convertUser(users)
  return (
    <Card className={classes.card}>
      <CardContent>
        <Box className={classes.mainContainer}>
          {Array.isArray(getValues) &&
            getValues.map((value) => (
              <Box key={Math.random()} className={classes.userContainer}>
                {Object.entries(value).map((element) => (
                  element[0] !==  'placa' && element[0] !== 'linea' && element[0] !== 'marca'&&
                  <Box key={Math.random()} className={classes.container}>
                    <Box className={classes.titles}>
                      <strong>{element[0]?.toUpperCase()}</strong>
                    </Box>
                    {alternative === 0 ? (
                      <Box className={classes.description}>
                        { element[1][0]?.toUpperCase()}
                      </Box>
                    ) : null}
                    {alternative === 1 ? (
                      <Box className={classes.description}>
                        {element[1][1]?.toUpperCase()}
                      </Box>
                    ) : null}
                    {alternative === 2 ? (
                      <Box className={classes.description}>
                        { element[1][2]?.toUpperCase()}
                      </Box>
                    ) : null}
                  </Box>
                ))}
              </Box>
          ))}
        </Box>
      </CardContent>
      <CardActions>
        <FormControl>
          <Select
            value={alternative}
            input={<Input />}
            onChange={(event) => onChangeFilter(event, 'info')}
          >
            <MenuItem value={0}>Información 1</MenuItem>
            <MenuItem value={1}>Información 2</MenuItem>
            <MenuItem value={2}>Información 3 </MenuItem>
          </Select>
        </FormControl>
      </CardActions>
    </Card>
  )
}

export default UserInfoByDocument
